import { DeviceHistory } from "../deviceTypes"
import { LocalizedStrict } from "../../../localization/components/AppLocalized"
import {
    DeviceDetailsBox,
    DeviceDetailsHeaderBox,
    DeviceDetailsInfoItem,
    DeviceDetailsSectionBoxTable,
} from "./DeviceDetailsDialogElements"
import { useDateTime } from "../../../localization/useDateTime"

type DeviceDetailsDialogHistorySectionProps = Readonly<{ history: DeviceHistory }>

export function DeviceDetailsDialogHistorySection({ history }: DeviceDetailsDialogHistorySectionProps) {
    const dateTimeFactory = useDateTime()
    const { created, updated } = history

    return (
        <DeviceDetailsBox>
            <LocalizedStrict id="device-details-history-info-title" attrs={{ title: true }}>
                <DeviceDetailsHeaderBox title="History" />
            </LocalizedStrict>
            <DeviceDetailsSectionBoxTable>
                <LocalizedStrict id="device-details-history-info-created" attrs={{ label: true }}>
                    <DeviceDetailsInfoItem label="Created:">
                        <span>{dateTimeFactory.formatDateTime(dateTimeFactory.fromApi(created.timestamp))}</span>
                        {/* No data in the request - created.author*/}
                        <span>{created.author}</span>
                    </DeviceDetailsInfoItem>
                </LocalizedStrict>
                <LocalizedStrict id="device-details-history-info-edited" attrs={{ label: true }}>
                    <DeviceDetailsInfoItem label="Edited:" hideLastRow={true} hide={!updated?.timestamp}>
                        <span>{dateTimeFactory.formatDateTime(dateTimeFactory.fromApi(updated.timestamp))}</span>
                        {/* No data in the request - updated.author*/}
                        <span>{updated.author}</span>
                    </DeviceDetailsInfoItem>
                </LocalizedStrict>
            </DeviceDetailsSectionBoxTable>
        </DeviceDetailsBox>
    )
}
